import {useRef, useState} from "react";

export default function useForceRender() {
    const [, setForceRender] = useState<number>(0);
    const forceRender = (triggerLoad = false) => {
        setForceRender(s => s + 1);

        if (triggerLoad) {
            if (typeof window !== "undefined") {
                /// browser code
                window.requestAnimationFrame(function() {
                    const event = new Event("load");
                    window.dispatchEvent(event);
                });
            }
        }
    };
    return forceRender;
}
